// Ishmael Interactive — Technology Cost Diagnostic
// ii-quiz.js — May 2026

(function () {

  // ─── CONFIG ──────────────────────────────────────────────────────────────────

  var II_COMPANY_ID = 'Wt9S2g';

  var II_LIST_IDS = {
    direct:     'RgpYSz',
    shadow:     'UUm24g',
    governance: 'SUsRdR',
    mixed:      'S7txQ7'
  };

  // ─── STATE ───────────────────────────────────────────────────────────────────

  var iiCurrentKey = null;
  var iiAnswers    = [];

  // ─── QUESTIONS ───────────────────────────────────────────────────────────────

  var iiQs = [
    {
      text: "We have a complete, current list of every tool in our technology stack and what it costs.",
      left: "Not true", right: "Completely true",
      cat: "direct", inv: true
    },
    {
      text: "Data regularly has to be moved, reformatted, or re-entered by hand between our systems.",
      left: "Rarely", right: "Constantly",
      cat: "shadow", inv: false
    },
    {
      text: "We have a documented policy for how staff use AI features in our existing platforms.",
      left: "No policy", right: "Fully documented",
      cat: "governance", inv: true
    },
    {
      text: "If a critical vendor relationship ended tomorrow, we have a documented plan for an organized response.",
      left: "No plan", right: "Clear plan",
      cat: "governance", inv: true
    },
    {
      text: "Leadership can demonstrate a clear return on our technology spend.",
      left: "Not confidently", right: "Yes, clearly",
      cat: "direct", inv: true
    },
    {
      text: "Technology, automation, and template investments have not noticeably decreased staff time required for repetitive work.",
      left: "Disagree", right: "Agree",
      cat: "shadow", inv: false
    }
  ];

  // ─── RESULT COPY ─────────────────────────────────────────────────────────────

  var iiResults = {
    direct: {
      ey: "Your quick win: the vendor list meeting",
      ti: "A 45-minute meeting could cut your software spend today.",
      bo: "You have the right instinct about your stack. You just have not had the time to act on it. Tools accumulate during projects. The projects end. The subscriptions do not.",
      tp: "Block 45 minutes with whoever handles your finance or operations. Pull every recurring software charge from the last 12 months, credit card statements not just invoices. Ask one question about each line: does someone use this every week? The ones where no one can answer yes are the ones you cancel first. Most organizations find at least one tool they forgot they had. Some find five."
    },
    shadow: {
      ey: "Your quick win: the handoff audit",
      ti: "One walk-through with your team will show you where the time is going.",
      bo: "Your stack is doing most of the work. The gaps between tools are where your staff fill in the rest, manually, quietly, and at a cost that never shows up on an invoice.",
      tp: "Pick your most common workflow and walk it end to end with the person who does it most. Count every time they copy something from one place to paste it into another, every export, reformat, re-entry. That number, multiplied across your team and your annual project volume, is your shadow cost. Write it down. Show it to your CFO. It changes the conversation."
    },
    governance: {
      ey: "Your quick win: the AI features conversation",
      ti: "One email to your team this week tells you everything you need to know.",
      bo: "Your vendors added AI features to tools your staff already use, usually quietly, usually in the tier you were already paying for. Getting ahead of how your team is using them is a one-email job.",
      tp: "Send this to your team this week. Subject line: Quick question about AI tools. Body: Are you using any AI features in the tools we already have? If so, on what kinds of data? The answers tell you whether you have a policy gap. Most organizations that ask this question for the first time are surprised by what comes back."
    },
    mixed: {
      ey: "Your quick win: one question at your next leadership meeting",
      ti: "One question at your next meeting makes the whole picture visible.",
      bo: "Your answers suggest costs in all three areas. The next step is not a full audit. It is a conversation that names what you already suspect.",
      tp: "At your next leadership meeting, ask: If we had to cut our technology spend by 20% by next quarter, what would we cut first, and what would break? The answers tell you which tools are load-bearing and which are just familiar. You do not have to cut anything. You just have to ask."
    }
  };

  // ─── INJECT STYLES ONCE ──────────────────────────────────────────────────────

  function iiInjectStyles() {
    if (document.getElementById('ii-email-styles')) return;
    var style = document.createElement('style');
    style.id = 'ii-email-styles';
    style.textContent = [
      '.ii-email-form {',
      '  background: #ffffff;',
      '  border-radius: 8px;',
      '  padding: 32px 24px;',
      '  margin-top: 24px;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  text-align: center;',
      '}',
      '.ii-email-heading {',
      '  font-size: 1.6rem;',
      '  font-weight: 700;',
      '  color: #1a1a1a;',
      '  margin: 0 0 20px 0;',
      '  line-height: 1.2;',
      '}',
      '.ii-email-input {',
      '  display: block;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  padding: 14px 16px;',
      '  font-size: 1rem;',
      '  border: 1.5px solid #d0d0d0;',
      '  border-radius: 6px;',
      '  margin-bottom: 10px;',
      '  outline: none;',
      '  transition: border-color 0.15s;',
      '  background: #fff;',
      '  color: #1a1a1a;',
      '}',
      '.ii-email-input:focus {',
      '  border-color: #1a1a1a;',
      '}',
      '.ii-email-input::placeholder {',
      '  color: #999;',
      '}',
      '.ii-email-submit {',
      '  display: block;',
      '  width: 100%;',
      '  box-sizing: border-box;',
      '  padding: 15px 16px;',
      '  font-size: 0.9rem;',
      '  font-weight: 600;',
      '  letter-spacing: 0.06em;',
      '  text-transform: uppercase;',
      '  color: #ffffff;',
      '  background: #1a1a1a;',
      '  border: none;',
      '  border-radius: 50px;',
      '  cursor: pointer;',
      '  transition: background 0.15s;',
      '}',
      '.ii-email-submit:hover:not(:disabled) {',
      '  background: #333333;',
      '}',
      '.ii-email-submit:disabled {',
      '  opacity: 0.6;',
      '  cursor: not-allowed;',
      '}',
      '.ii-email-status {',
      '  margin-top: 12px;',
      '  font-size: 0.9rem;',
      '  line-height: 1.4;',
      '}',
      '.ii-email-status--success {',
      '  color: #2d6a4f;',
      '}',
      '.ii-email-status--error {',
      '  color: #c0392b;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ─── BUILD QUESTIONS ─────────────────────────────────────────────────────────

  function iiBuild() {
    var list = document.getElementById('ii-q-list');
    if (!list) return;

    iiAnswers = Array(iiQs.length).fill(null);

    iiQs.forEach(function (q, qi) {
      var item = document.createElement('div');
      item.className = 'ii-q-item';

      var num = document.createElement('div');
      num.className = 'ii-q-num';
      num.textContent = '0' + (qi + 1);

      var text = document.createElement('div');
      text.className = 'ii-q-text';
      text.textContent = q.text;

      var likert = document.createElement('div');
      likert.className = 'ii-likert';

      var labelLeft = document.createElement('span');
      labelLeft.className = 'ii-scale-label';
      labelLeft.textContent = q.left;

      var dots = document.createElement('div');
      dots.className = 'ii-dots';
      dots.id = 'ii-dots-' + qi;

      var labelRight = document.createElement('span');
      labelRight.className = 'ii-scale-label right';
      labelRight.textContent = q.right;

      for (var i = 1; i <= 5; i++) {
        var btn = document.createElement('button');
        btn.className = 'ii-dot';
        btn.setAttribute('aria-label', 'Question ' + (qi + 1) + ', rating ' + i + ' of 5');
        btn.setAttribute('data-q', qi);
        btn.setAttribute('data-v', i);
        btn.setAttribute('type', 'button');
        dots.appendChild(btn);
      }

      likert.appendChild(labelLeft);
      likert.appendChild(dots);
      likert.appendChild(labelRight);

      item.appendChild(num);
      item.appendChild(text);
      item.appendChild(likert);
      list.appendChild(item);
    });

    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.ii-dot');
      if (!btn) return;
      e.preventDefault();
      iiSelect(
        parseInt(btn.getAttribute('data-q'), 10),
        parseInt(btn.getAttribute('data-v'), 10)
      );
    });

    var submitBtn = document.getElementById('ii-submit');
    if (submitBtn) {
      submitBtn.setAttribute('type', 'button');
      submitBtn.disabled = true;
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        iiShowResult();
      });
    }
  }

  // ─── HANDLE DOT SELECTION ────────────────────────────────────────────────────

  function iiSelect(qIdx, val) {
    iiAnswers[qIdx] = val;

    document.querySelectorAll('#ii-dots-' + qIdx + ' .ii-dot').forEach(function (d, i) {
      d.classList.toggle('selected', i + 1 === val);
    });

    var answered = iiAnswers.filter(function (a) { return a !== null; }).length;
    var rem      = iiQs.length - answered;

    var hint = document.getElementById('ii-hint');
    if (hint) {
      hint.textContent = rem === 0
        ? 'All done. See your results.'
        : rem + ' question' + (rem === 1 ? '' : 's') + ' remaining.';
    }

    var submitBtn = document.getElementById('ii-submit');
    if (submitBtn) submitBtn.disabled = answered < iiQs.length;
  }

  // ─── SCORE & SHOW RESULT CARD ─────────────────────────────────────────────────

  function iiShowResult() {
    var scores = { direct: 0, shadow: 0, governance: 0 };

    iiQs.forEach(function (q, i) {
      var raw = iiAnswers[i] !== null ? iiAnswers[i] : 3;
      scores[q.cat] += q.inv ? (6 - raw) : raw;
    });

    var max     = Math.max(scores.direct, scores.shadow, scores.governance);
    var winners = Object.keys(scores).filter(function (k) { return scores[k] === max; });
    var key     = winners.length > 1 ? 'mixed' : winners[0];
    iiCurrentKey = key;

    var r = iiResults[key];

    var qList     = document.getElementById('ii-q-list');
    var submitRow = document.querySelector('.ii-submit-row');
    var rs        = document.getElementById('ii-result');

    if (qList)     qList.style.display     = 'none';
    if (submitRow) submitRow.style.display = 'none';

    if (!rs) return;
    rs.innerHTML = '';
    rs.style.display = 'block';

    var eyebrow = document.createElement('div');
    eyebrow.className   = 'ii-result-eyebrow';
    eyebrow.textContent = r.ey;

    var title = document.createElement('div');
    title.className   = 'ii-result-title';
    title.textContent = r.ti;

    var body = document.createElement('div');
    body.className   = 'ii-result-body';
    body.textContent = r.bo;

    var tryBox = document.createElement('div');
    tryBox.className = 'ii-try-box';

    var tryLabel = document.createElement('div');
    tryLabel.className   = 'ii-try-label';
    tryLabel.textContent = 'Try this';

    var tryText = document.createElement('div');
    tryText.className   = 'ii-try-text';
    tryText.textContent = r.tp;

    tryBox.appendChild(tryLabel);
    tryBox.appendChild(tryText);

    var moreBtn = document.createElement('button');
moreBtn.className = 'ii-btn-more';
moreBtn.setAttribute('type', 'button');
moreBtn.textContent = 'Tell me more about this result';
moreBtn.addEventListener('click', function (e) {
  e.preventDefault();
  iiShowExp(key);
});

   

    var footnote = document.createElement('p');
    footnote.className   = 'ii-result-footnote';
    footnote.textContent = 'The tip above is something you can use this week.';

    var retake = document.createElement('button');
    retake.className = 'ii-retake';
    retake.setAttribute('type', 'button');
    retake.textContent = 'Start over';
    retake.addEventListener('click', function (e) {
      e.preventDefault();
      iiRetake();
    });

    rs.appendChild(eyebrow);
    rs.appendChild(title);
    rs.appendChild(body);
    rs.appendChild(tryBox);
    rs.appendChild(moreBtn);
    rs.appendChild(footnote);
    rs.appendChild(retake);
  }

  // ─── SHOW EXPLANATION + EMAIL FORM ──────────────────────────────────────────

  function iiShowExp(key) {
    ['direct', 'shadow', 'governance', 'mixed'].forEach(function (k) {
      var el = document.getElementById('ii-exp-' + k);
      if (el) el.style.display = 'none';
    });

    var el = document.getElementById('ii-exp-' + key);
    if (!el) return;

    if (!el.querySelector('.ii-email-form')) {
      iiInjectForm(el, key);
    }

    el.style.display    = 'block';
    el.style.visibility = 'visible';
    el.style.position   = 'relative';
    el.style.height     = 'auto';
    el.style.overflow   = 'visible';

    setTimeout(function () {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  }

  // ─── BUILD & INJECT STYLED EMAIL FORM ────────────────────────────────────────

  function iiInjectForm(container, key) {
    var listId = II_LIST_IDS[key];

    var wrapper = document.createElement('div');
    wrapper.className = 'ii-email-form';

    var heading = document.createElement('p');
    heading.className   = 'ii-email-heading';
    heading.textContent = 'Email me this write up.';

    var input = document.createElement('input');
    input.type        = 'email';
    input.id          = 'ii-email-' + key;
    input.name        = 'email';
    input.placeholder = 'Email';
    input.className   = 'ii-email-input';
    input.required    = true;

    var submitBtn = document.createElement('button');
    submitBtn.type        = 'button';
    submitBtn.className   = 'ii-email-submit';
    submitBtn.textContent = 'Send email';

    var status = document.createElement('div');
    status.className     = 'ii-email-status';
    status.style.display = 'none';

    submitBtn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!iiValidEmail(email)) {
        iiSetStatus(status, 'Please enter a valid email address.', 'error');
        return;
      }
      submitBtn.disabled    = true;
      submitBtn.textContent = 'Sending\u2026';
      iiSubscribe(email, listId, function (ok, msg) {
        if (ok) {
          input.style.display     = 'none';
          submitBtn.style.display = 'none';
          iiSetStatus(status, 'You\u2019re on the list. Check your inbox shortly.', 'success');
        } else {
          submitBtn.disabled    = false;
          submitBtn.textContent = 'Send email';
          iiSetStatus(status, msg || 'Something went wrong. Please try again.', 'error');
        }
      });
    });

    wrapper.appendChild(heading);
    wrapper.appendChild(input);
    wrapper.appendChild(submitBtn);
    wrapper.appendChild(status);

    container.appendChild(wrapper);
  }

  // ─── KLAVIYO CLIENT API SUBSCRIPTION ─────────────────────────────────────────

  function iiSubscribe(email, listId, callback) {
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + II_COMPANY_ID;

    var payload = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    });

    fetch(url, {
      method:  'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision':     '2024-10-15'
      },
      body: payload
    })
    .then(function (res) {
      if (res.status === 202 || res.status === 200) {
        callback(true);
      } else {
        res.json().then(function (data) {
          var msg = (data && data.errors && data.errors[0] && data.errors[0].detail)
            ? data.errors[0].detail
            : 'Submission failed (status ' + res.status + ').';
          callback(false, msg);
        }).catch(function () {
          callback(false, 'Submission failed (status ' + res.status + ').');
        });
      }
    })
    .catch(function () {
      callback(false, 'Network error. Please check your connection and try again.');
    });
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────────

  function iiValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function iiSetStatus(el, msg, type) {
    el.textContent   = msg;
    el.className     = 'ii-email-status ii-email-status--' + type;
    el.style.display = 'block';
  }

  // ─── RETAKE ──────────────────────────────────────────────────────────────────

  function iiRetake() {
    iiAnswers    = Array(iiQs.length).fill(null);
    iiCurrentKey = null;

    var qList     = document.getElementById('ii-q-list');
    var submitRow = document.querySelector('.ii-submit-row');
    var rs        = document.getElementById('ii-result');
    var hint      = document.getElementById('ii-hint');
    var submitBtn = document.getElementById('ii-submit');

    if (qList)     qList.style.display     = 'block';
    if (submitRow) submitRow.style.display = 'flex';
    if (rs)        { rs.style.display = 'none'; rs.innerHTML = ''; }
    if (hint)      hint.textContent = 'Answer all six to see your results.';
    if (submitBtn) submitBtn.disabled = true;

    document.querySelectorAll('.ii-dot').forEach(function (d) {
      d.classList.remove('selected');
    });

    ['direct', 'shadow', 'governance', 'mixed'].forEach(function (k) {
      var exp = document.getElementById('ii-exp-' + k);
      if (exp) exp.style.display = 'none';
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // ─── HIDE EXPLANATION SECTIONS ON LOAD ──────────────────────────────────────

  function iiHideExp() {
    ['direct', 'shadow', 'governance', 'mixed'].forEach(function (k) {
      var el = document.getElementById('ii-exp-' + k);
      if (el) el.style.display = 'none';
    });
  }

  // ─── INIT ────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iiInjectStyles();
      iiHideExp();
      iiBuild();
    });
  } else {
    iiInjectStyles();
    iiHideExp();
    iiBuild();
  }

})();
